interface StepProgressProps {
  step: number;
  total?: number;
  brandColor: string;
  label: string;
}

export function StepProgress({ step, total = 3, brandColor, label }: StepProgressProps) {
  return (
    <div className="flex items-center gap-3">
      <div className="flex flex-1 gap-1.5">
        {Array.from({ length: total }, (_, i) => i + 1).map((n) => {
          const filled = n <= step;
          return (
            <div
              key={n}
              data-filled={filled}
              className="h-1 flex-1 rounded-sm"
              style={{ background: filled ? brandColor : '#e6e7ea' }}
            />
          );
        })}
      </div>
      <span className="whitespace-nowrap text-xs font-bold tracking-wide text-[#8a8f98]">
        {label}
      </span>
    </div>
  );
}
